/* eslint-disable no-lone-blocks */
import axios, { AxiosRequestConfig } from "axios";
import { paths } from "./ServiceConstants";
import { toast } from "react-toastify";
import { getFromLocalStorage } from "../utils/Util";
import { STORAGE_KEY } from "../utils/Constant";
import { refreshAuthToken } from "../utils/AuthUtils";
const ServicesManagerAPICall = {

  request: async (
    methodType: string,
    endpoint: string,
    data?: any,
    hasAuthToken: boolean = true,
    multipart: boolean = false,
    isCrop: boolean = false,
    isGis:boolean=false,
  ) => {

    let queryParams: string = "?";
    let url: any;
    let authenticationDatum: any;
    const authData: any = JSON.parse(getFromLocalStorage(STORAGE_KEY.AUTH_DATA));
    const userName = authData?.employeeName ? authData?.employeeName.split(':')[0] : ""
    if (hasAuthToken) {
       authenticationDatum = authData;
    }
    const currentTimestamp = Math.floor(Date.now() / 1000);
    if (authenticationDatum?.accessExpiryTime < currentTimestamp) {
      try {
       let rToken = await refreshAuthToken(authenticationDatum?.resetToken);
        authenticationDatum = JSON.parse(getFromLocalStorage(STORAGE_KEY.AUTH_DATA) ?? "{}");
      } catch (error) {
        console.error("Token refresh failed", error);
        return;
      }
    }   
     const config: AxiosRequestConfig = {
      method: "",
      url: "",
      headers: hasAuthToken
        ? {
             Authorization: `Bearer ${authenticationDatum?.accessToken}`,
            // Authorization:
            //   "Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJnb3V0aGFtIiwiaWF0IjoxNzE5MjExODA5fQ.HcTqqzguypZoeX1omcx-fvvad3V-sAZ5f1LYqaYX0fc",
            "Content-Type": multipart
              ? "multipart/form-data"
              : "application/json",
              'requester': `${userName}`
          }
        : {
            Authorization: `Basic ${paths.basicAuthString}`,
            "Content-Type": "application/json",
            'requester': `${userName}`
          },
    };

    try {
      switch (methodType) {
        case "GET":
          {
            if (data) {
              for (const key in data) {
                queryParams += `${key}=${data[key]}&`;
              }
              url = isCrop===true?`${paths.CROPS_URL}${endpoint}${queryParams}`:(isGis===true?`${paths.GIS_URL}${endpoint}${queryParams}`:`${paths.BASE_URL}${endpoint}${queryParams}`);
            } else {
              url = isCrop===true?`${paths.CROPS_URL}${endpoint}`:(isGis===true?`${paths.GIS_URL}${endpoint}`:`${paths.BASE_URL}${endpoint}`);
            }
            config.method = `${methodType.toLowerCase()}`;
            config.url = url;
          }
          break;
          case "POST":
            {
              url = isCrop === true
                ? `${paths.CROPS_URL}${endpoint}`
                : (isGis === true
                  ? `${paths.GIS_URL}${endpoint}`
                  : `${paths.BASE_URL}${endpoint}`);
           
              config.method = `${methodType.toLowerCase()}`;
              config.url = url;
           
              if (data) {
                config.data = data;  // Attach data directly to the request body
              }
           
              console.log("Request URL:", url);
              console.log("Request Body:", config.data);
            }
            break;
        // case "POST":
        //   {
        //     if (data) {
        //       for (const key in data) {
        //         queryParams += `${key}=${data[key]}&`;
        //       }
        //       url = isCrop===true?`${paths.CROPS_URL}${endpoint}${queryParams}`:(isGis===true?`${paths.GIS_URL}${endpoint}${queryParams}`:`${paths.BASE_URL}${endpoint}${queryParams}`);
        //       console.log(url)
        //     } else {
        //       url = isCrop===true?`${paths.CROPS_URL}${endpoint}`:(isGis===true?`${paths.GIS_URL}${endpoint}`:`${paths.BASE_URL}${endpoint}`);
        //     }
        //     config.method = `${methodType.toLowerCase()}`;
        //     config.url = url;
        //   }
        //   break;
        case "PUT":
        case "PATCH":
          {
            config.method = `${methodType.toLowerCase()}`;
            config.url = isCrop===true?`${paths.CROPS_URL}${endpoint}`:`${paths.BASE_URL}${endpoint}`;
            config.data = data;
          }
          break;

        case "DELETE":
        case "OPTIONS":
          {
            config.method = `${methodType.toLowerCase()}`;
            config.url = `${paths.BASE_URL}${endpoint}`;
          }
          break;

        default:
          throw new Error(`Unsupported method type: ${methodType}`);
      }

      const response = await axios(config);
      if (response.status === 200) {
        return response.data ?? {};
      }
    } catch (error: any) {
      toast.error("Unable fetch the data, Please try again.");
      return error.message;
    }
  },
};

export default ServicesManagerAPICall;
